/* Allsson certified-partner locator — vanilla port of InstallerMap + Locator. */
(function () {
  var REGIONS = [
    { id: "all", label: "All regions" },
    { id: "nordics", label: "Nordics", center: [15, 60], scale: 5.2 },
    { id: "europe", label: "Europe", center: [10, 50], scale: 3.4 }
  ];
  var INSTALLERS = [
    { id: "tre", name: "Allsson Studio", city: "Tampere", country: "Finland", region: "nordics",
      coords: [23.761, 61.4978], tier: "flagship",
      phone: "+358 45 177 8780", email: "info@allsson.com",
      address: "Lakalaivankatu 10, Tampere, 33840", web: "www.allsson.com" }
  ];
  var WORLD = "https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json";
  var MIN_K = 1, MAX_K = 14, FOCUS_K = 4.6;
  var SVGNS = "http://www.w3.org/2000/svg";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); };
  function el(tag, cls, attrs) { var n = document.createElementNS(SVGNS, tag); if (cls) n.setAttribute("class", cls); for (var k in attrs || {}) n.setAttribute(k, attrs[k]); return n; }
  function km(a, b) {
    var R = 6371, rad = function (d) { return d * Math.PI / 180; };
    var dLat = rad(b[1] - a[1]), dLon = rad(b[0] - a[0]);
    var h = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(rad(a[1])) * Math.cos(rad(b[1])) * Math.pow(Math.sin(dLon / 2), 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  function resolveOrigin(q) {
    var s = q.trim().toLowerCase();
    if (!s) return null;
    var c = INSTALLERS.filter(function (i) { return i.city.toLowerCase() === s; })[0]
      || INSTALLERS.filter(function (i) { return i.city.toLowerCase().indexOf(s) === 0; })[0]
      || INSTALLERS.filter(function (i) { return i.city.toLowerCase().indexOf(s) > -1; })[0];
    if (c) return { coords: c.coords, label: c.city + ", " + c.country };
    var n = INSTALLERS.filter(function (i) { return i.country.toLowerCase() === s; })[0]
      || INSTALLERS.filter(function (i) { return i.country.toLowerCase().indexOf(s) > -1; })[0];
    return n ? { coords: n.coords, label: n.country } : null;
  }

  function Map(host, opts) {
    var d3 = window.d3, topojson = window.topojson;
    var wrap = document.createElement("div");
    wrap.className = "als-loc als-loc--maponly";
    wrap.setAttribute("data-theme", "dark");
    wrap.style.setProperty("--als-loc-h", (opts.height || 620) + "px");
    wrap.innerHTML = '<div class="als-loc__mapwrap"><div class="als-loc__regions"></div><span class="als-loc__loading">Loading map</span><div class="als-loc__zoom" hidden><button type="button" class="als-loc__zbtn" aria-label="Zoom in">+</button><button type="button" class="als-loc__zbtn" aria-label="Zoom out">\u2212</button><button type="button" class="als-loc__zbtn als-loc__zbtn--reset" aria-label="Reset view">Reset</button></div><div class="als-loc__tip" hidden></div></div>';
    host.appendChild(wrap);
    var mapwrap = $(".als-loc__mapwrap", wrap), loading = $(".als-loc__loading", wrap);
    var zoomBox = $(".als-loc__zoom", wrap), tip = $(".als-loc__tip", wrap);
    var chips = $(".als-loc__regions", wrap);
    var region = opts.initialRegion || "all", active = null, origin = null, world = null;
    var cam = { x: 0, y: 0, k: 1 }, glide = true, view = null, svg = null, gRoot = null, pins = {};
    var drag = null, dragged = false, framed = false;

    REGIONS.forEach(function (r) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "als-loc__chip"; b.textContent = r.label;
      b.setAttribute("aria-pressed", r.id === region ? "true" : "false");
      b.addEventListener("click", function () {
        region = r.id;
        [].forEach.call(chips.children, function (c) { c.setAttribute("aria-pressed", c === b ? "true" : "false"); });
        setActive(null);
        if (r.center && r.scale) focus(r.center, r.scale); else reset();
        paintDim();
      });
      chips.appendChild(b);
    });

    function clampK(k) { return Math.min(MAX_K, Math.max(MIN_K, k)); }
    function applyCam() {
      if (!gRoot) return;
      gRoot.style.transform = "translate(" + cam.x + "px," + cam.y + "px) scale(" + cam.k + ")";
      gRoot.style.transition = glide ? "transform 700ms cubic-bezier(.16,1,.3,1)" : "none";
      sizePins();
    }
    function focus(lonlat, k) {
      if (!view) return;
      var p = view.projection(lonlat);
      if (!p) return;
      var kk = clampK(k);
      glide = true;
      cam = { x: mapwrap.clientWidth / 2 - p[0] * kk, y: mapwrap.clientHeight / 2 - p[1] * kk, k: kk };
      applyCam();
    }
    function reset() { glide = true; cam = { x: 0, y: 0, k: 1 }; applyCam(); }
    function zoomBy(f) {
      glide = true;
      var w = mapwrap.clientWidth / 2, h = mapwrap.clientHeight / 2;
      var k = clampK(cam.k * f), ratio = k / cam.k;
      cam = { k: k, x: w - (w - cam.x) * ratio, y: h - (h - cam.y) * ratio };
      applyCam();
    }
    zoomBox.children[0].addEventListener("click", function () { zoomBy(1.6); });
    zoomBox.children[1].addEventListener("click", function () { zoomBy(1 / 1.6); });
    zoomBox.children[2].addEventListener("click", function () {
      region = "all";
      [].forEach.call(chips.children, function (c, i) { c.setAttribute("aria-pressed", i === 0 ? "true" : "false"); });
      setActive(null); reset(); paintDim();
    });

    function sizePins() {
      Object.keys(pins).forEach(function (id) {
        var g = pins[id], i = g.__inst;
        var r = (i.tier === "flagship" ? 4 : 3) / cam.k;
        g.__pin.setAttribute("r", r);
        g.__halo.setAttribute("r", r * 2.4);
        g.__hit.setAttribute("r", Math.max(r * 3.4, 9 / cam.k));
        if (g.__ping) g.__ping.setAttribute("r", r * 1.8);
      });
    }
    function paintDim() {
      Object.keys(pins).forEach(function (id) {
        var i = pins[id].__inst;
        pins[id].setAttribute("data-dim", region !== "all" && i.region !== region ? "true" : "false");
      });
    }
    function setActive(id) {
      active = id;
      Object.keys(pins).forEach(function (k) { pins[k].setAttribute("data-active", k === id ? "true" : "false"); });
    }

    function build() {
      if (!d3 || !topojson || !world) { loading.textContent = "Map unavailable"; return; }
      var w = mapwrap.clientWidth, h = mapwrap.clientHeight;
      if (!w || !h) return;
      var projection = d3.geoNaturalEarth1().fitExtent([[8, 14], [w - 8, h - 14]], { type: "Sphere" });
      var b = d3.geoPath(projection).bounds({ type: "Sphere" });
      var bw = b[1][0] - b[0][0], bh = b[1][1] - b[0][1];
      if (bw > 0 && bh > 0) {
        var cover = Math.max(w / bw, h / bh);
        if (cover > 1.001) {
          projection.scale(projection.scale() * cover);
          var b2 = d3.geoPath(projection).bounds({ type: "Sphere" });
          var t = projection.translate();
          projection.translate([t[0] + (w - (b2[1][0] + b2[0][0])) / 2, t[1] + (h - (b2[1][1] + b2[0][1])) / 2]);
        }
      }
      var path = d3.geoPath(projection);
      view = { projection: projection, path: path };
      var land = topojson.feature(world, world.objects.countries);

      if (svg) svg.remove();
      svg = el("svg", "als-loc__svg", { viewBox: "0 0 " + w + " " + h, role: "img", "aria-label": "Installer locations" });
      svg.appendChild(el("path", "als-loc__sphere", { d: path({ type: "Sphere" }) }));
      gRoot = el("g");
      svg.appendChild(gRoot);
      gRoot.appendChild(el("path", "als-loc__grat", { d: path(d3.geoGraticule10()) }));
      land.features.forEach(function (f) { gRoot.appendChild(el("path", "als-loc__land", { d: path(f) })); });
      pins = {};
      INSTALLERS.forEach(function (i) {
        var p = projection(i.coords);
        if (!p) return;
        var g = el("g", "als-loc__g");
        g.__inst = i;
        g.__ping = el("circle", "als-loc__ping", { cx: p[0], cy: p[1], r: 5 });
        g.__halo = el("circle", "als-loc__halo", { cx: p[0], cy: p[1], r: 7 });
        g.__pin = el("circle", "als-loc__pin" + (i.tier === "flagship" ? " als-loc__pin--flagship" : ""), { cx: p[0], cy: p[1], r: 3 });
        g.__hit = el("circle", "als-loc__hit", { cx: p[0], cy: p[1], r: 9 });
        g.appendChild(g.__ping); g.appendChild(g.__halo); g.appendChild(g.__pin); g.appendChild(g.__hit);
        g.addEventListener("mouseenter", function () {
          tip.hidden = false;
          tip.innerHTML = '<span class="als-loc__tipcity">' + esc(i.city) + '</span><span class="als-loc__tipname">' + esc(i.name) + "</span>";
          tip.style.left = (cam.x + p[0] * cam.k) + "px";
          tip.style.top = (cam.y + p[1] * cam.k) + "px";
        });
        g.addEventListener("mouseleave", function () { tip.hidden = true; });
        g.addEventListener("click", function () {
          if (dragged || g.getAttribute("data-dim") === "true") return;
          setActive(i.id); focus(i.coords, Math.max(cam.k, FOCUS_K));
          if (opts.onSelect) opts.onSelect(i);
        });
        gRoot.appendChild(g);
        pins[i.id] = g;
      });
      mapwrap.insertBefore(svg, zoomBox);
      loading.hidden = true;
      zoomBox.hidden = false;

      svg.addEventListener("pointerdown", function (e) {
        if (e.button !== 0) return;
        drag = { px: e.clientX, py: e.clientY, ox: cam.x, oy: cam.y, moved: false };
        glide = false;
        svg.setPointerCapture(e.pointerId);
      });
      svg.addEventListener("pointermove", function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.px, dy = e.clientY - drag.py;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) drag.moved = true;
        cam.x = drag.ox + dx; cam.y = drag.oy + dy;
        applyCam();
      });
      var end = function (e) {
        if (drag && svg.hasPointerCapture && svg.hasPointerCapture(e.pointerId)) svg.releasePointerCapture(e.pointerId);
        dragged = !!(drag && drag.moved);
        drag = null;
        setTimeout(function () { dragged = false; }, 0);
      };
      svg.addEventListener("pointerup", end);
      svg.addEventListener("pointercancel", end);
      svg.addEventListener("wheel", function (e) {
        if (!(e.ctrlKey || e.metaKey)) return;
        e.preventDefault();
        var box = svg.getBoundingClientRect();
        var mx = e.clientX - box.left, my = e.clientY - box.top;
        var k = clampK(cam.k * (1 - e.deltaY * 0.0015)), ratio = k / cam.k;
        cam = { k: k, x: mx - (mx - cam.x) * ratio, y: my - (my - cam.y) * ratio };
        glide = false;
        applyCam();
      }, { passive: false });

      paintDim();
      if (!framed) {
        framed = true;
        var r0 = REGIONS.filter(function (x) { return x.id === (opts.initialRegion || "all"); })[0];
        glide = false;
        if (r0 && r0.center) focus(r0.center, r0.scale); else applyCam();
        requestAnimationFrame(function () { glide = true; });
      } else applyCam();
      if (origin) drawOrigin();
    }

    var originG = null;
    function drawOrigin() {
      if (originG) { originG.remove(); originG = null; }
      if (!origin || !view || !gRoot) return;
      var p = view.projection(origin);
      if (!p) return;
      originG = el("g", "als-loc__origin");
      originG.appendChild(el("circle", "als-loc__originring", { cx: p[0], cy: p[1], r: 7 / cam.k }));
      originG.appendChild(el("circle", "als-loc__origindot", { cx: p[0], cy: p[1], r: 3 / cam.k }));
      gRoot.appendChild(originG);
    }

    fetch(WORLD).then(function (r) { return r.json(); }).then(function (t) { world = t; build(); }).catch(function () { loading.textContent = "Map unavailable"; });
    var ro = window.ResizeObserver ? new ResizeObserver(function () { if (world) build(); }) : null;
    if (ro) ro.observe(mapwrap);

    return {
      select: function (i) { setActive(i.id); focus(i.coords, Math.max(cam.k, FOCUS_K)); },
      setOrigin: function (o) { origin = o; drawOrigin(); if (o) focus(o, Math.max(cam.k, 3.4)); },
      node: mapwrap
    };
  }

  function card(i, dist, activeId) {
    var tel = i.phone ? i.phone.replace(/\s/g, "") : null;
    var dir = "https://www.google.com/maps/dir/?api=1&destination=" + i.coords[1] + "," + i.coords[0];
    return '<article class="loc__card" data-active="' + (i.id === activeId) + '" data-id="' + i.id + '">' +
      '<header class="loc__cardtop"><div><h4 class="loc__cardname">' + esc(i.name) + '</h4>' +
      '<span class="loc__cardplace">' + esc(i.city) + ", " + esc(i.country) + '</span></div>' +
      '<span class="als-badge als-badge--' + (i.tier === "flagship" ? "gradient" : "ice") + '">' + (i.tier === "flagship" ? "Flagship" : "Certified") + "</span></header>" +
      '<div class="loc__cardmeta">' + (dist != null ? '<span class="loc__dist">' + (dist < 10 ? dist.toFixed(1) : Math.round(dist)) + " km away</span>" : "") + "</div>" +
      (tel || i.email || i.address || i.web ? '<dl class="loc__contact">' +
        (i.address ? "<div><dt>Address</dt><dd>" + esc(i.address) + "</dd></div>" : "") +
        (tel ? "<div><dt>Phone</dt><dd><a href=\"tel:" + tel + '">' + esc(i.phone) + "</a></dd></div>" : "") +
        (i.email ? "<div><dt>Email</dt><dd><a href=\"mailto:" + esc(i.email) + '">' + esc(i.email) + "</a></dd></div>" : "") +
        (i.web ? "<div><dt>Web</dt><dd><a href=\"https://" + esc(i.web) + '" target="_blank" rel="noreferrer">' + esc(i.web) + "</a></dd></div>" : "") + "</dl>" : "") +
      '<div class="loc__cardacts">' +
      (tel ? '<a class="als-btn als-btn--primary als-btn--sm" href="tel:' + tel + '">Call</a>' : "") +
      (i.email ? '<a class="als-btn als-btn--secondary als-btn--sm" href="mailto:' + esc(i.email) + '">Message</a>' : "") +
      '<a class="loc__dirlink" href="' + dir + '" target="_blank" rel="noopener noreferrer">Get directions<span aria-hidden="true"> \u2197</span></a>' +
      "</div></article>";
  }

  function boot() {
    var root = document.querySelector("[data-als-locator]");
    if (!root) return;
    var mapCol = $(".loc__mapcol", root), listCol = $(".loc__listcol", root);
    var form = $(".loc__form", root), input = $(".loc__input", root);
    var geoBtn = $(".loc__geo", root), geoErr = $(".loc__geoerr", root), originLine = $(".loc__originline", root);
    var origin = null, activeId = null, status = "idle";
    var map = Map(mapCol, { height: 620, initialRegion: "europe", onSelect: function (i) { activeId = i.id; render(); } });

    function results() {
      if (!origin) return INSTALLERS.map(function (i) { return { i: i, d: null }; });
      return INSTALLERS.map(function (i) { return { i: i, d: km(origin.coords, i.coords) }; }).sort(function (a, b) { return a.d - b.d; });
    }
    function render() {
      var all = results();
      var show = origin ? all.slice(0, 8) : all;
      if (status === "searching") {
        listCol.innerHTML = '<div class="loc__loading"><span class="loc__spin"></span><span class="loc__loadingtext">Finding partners near you</span></div>';
        return;
      }
      if (status === "notfound") {
        listCol.innerHTML = '<div class="loc__empty"><h4 class="loc__emptytitle">No partners matched that.</h4><p class="loc__emptynote">We couldn\u2019t place that search. Try a nearby city, or get in touch and we\u2019ll find the closest partner for you.</p><button type="button" class="als-btn als-btn--secondary" data-als-showall>Show all partners</button></div>';
        return;
      }
      listCol.innerHTML = '<div class="loc__listhead"><span class="als-eyebrow">' + (origin ? "Nearest first" : "All partners (" + all.length + ")") + "</span></div>" +
        '<div class="loc__cards">' + show.map(function (r) { return card(r.i, r.d, activeId); }).join("") + "</div>" +
        (origin && all.length > show.length ? '<p class="loc__more">Showing the ' + show.length + " closest of " + all.length + " partners.</p>" : "");
    }
    listCol.addEventListener("click", function (e) {
      if (e.target.closest("[data-als-showall]")) { input.value = ""; origin = null; status = "idle"; originLine.hidden = true; map.setOrigin(null); render(); return; }
      if (e.target.closest("a")) return;
      var c = e.target.closest(".loc__card");
      if (!c) return;
      var i = INSTALLERS.filter(function (x) { return x.id === c.getAttribute("data-id"); })[0];
      if (!i) return;
      activeId = i.id;
      map.select(i);
      render();
      if (window.matchMedia("(max-width:640px)").matches) {
        window.scrollTo({ top: Math.max(0, mapCol.getBoundingClientRect().top + window.scrollY - 72), behavior: "smooth" });
      }
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      geoErr.hidden = true;
      if (!input.value.trim()) { origin = null; status = "idle"; originLine.hidden = true; map.setOrigin(null); render(); return; }
      status = "searching"; render();
      setTimeout(function () {
        var hit = resolveOrigin(input.value);
        if (!hit) { origin = null; status = "notfound"; originLine.hidden = true; map.setOrigin(null); render(); return; }
        origin = hit; status = "done";
        originLine.hidden = false;
        $("[data-als-originlabel]", originLine).textContent = hit.label;
        map.setOrigin(hit.coords);
        render();
      }, 400);
    });
    $(".loc__clear", originLine).addEventListener("click", function () {
      origin = null; input.value = ""; status = "idle"; originLine.hidden = true; map.setOrigin(null); render();
    });
      function fireGeo() {
      var sheet = document.querySelector(".geoask");
      if (sheet) sheet.remove();
      geoErr.hidden = true; status = "searching"; render();
      navigator.geolocation.getCurrentPosition(function (pos) {
        origin = { coords: [pos.coords.longitude, pos.coords.latitude], label: "Your location" };
        input.value = ""; status = "done";
        originLine.hidden = false;
        $("[data-als-originlabel]", originLine).textContent = origin.label;
        map.setOrigin(origin.coords);
        render();
      }, function (err) {
        status = "idle"; render();
        geoErr.hidden = false;
        geoErr.textContent = err && err.code === 1
          ? "Location is off for this site. Turn it on in your browser settings, or type a city below."
          : "We couldn't get a fix on your location. Type a city below instead.";
      }, { timeout: 8000, enableHighAccuracy: true, maximumAge: 60000 });
    }
    /* The OS prompt states no reason and a denial is sticky on mobile, so the
       ask is explained first and the browser prompt fires only on opt-in. */
    function askGeo() {
      if (document.querySelector(".geoask")) return;
      var w = document.createElement("div");
      w.className = "geoask";
      w.setAttribute("role", "dialog");
      w.setAttribute("aria-modal", "true");
      w.innerHTML = '<button type="button" class="geoask__scrim" aria-label="Cancel"></button>' +
        '<div class="geoask__sheet" data-theme="dark">' +
        '<span class="geoask__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"></path><circle cx="12" cy="10" r="2.6"></circle></svg></span>' +
        '<h4 class="geoask__title">Find the nearest certified partner</h4>' +
        '<p class="geoask__note">Share your location and we\'ll sort every certified partner by distance from you. Your browser will ask to confirm \u2014 we only read it to order the list, and never store it.</p>' +
        '<div class="geoask__acts"><button type="button" class="als-btn als-btn--primary als-btn--lg als-btn--block" data-geo-ok>Share my location</button>' +
        '<button type="button" class="geoask__deny" data-geo-no>Not now</button></div></div>';
      document.body.appendChild(w);
      w.querySelector("[data-geo-ok]").addEventListener("click", fireGeo);
      w.querySelector("[data-geo-no]").addEventListener("click", function () { w.remove(); });
      w.querySelector(".geoask__scrim").addEventListener("click", function () { w.remove(); });
    }
    geoBtn.addEventListener("click", function () {
      if (!navigator.geolocation) { geoErr.hidden = false; geoErr.textContent = "This browser can't share a location."; return; }
      askGeo();
    });
    render();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
